import { AxiosResponse, AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { TagApiError } from '../utils/analytics-tagging';
import {
  IReturnEligibilityRequest,
  IReturnEligibilityResponse,
} from '../models/api';
import { IReturnsAlert } from '../models/returns';
import { ReturnEligibilityAPI } from '../api/returns';
import { IGenericError } from '../models/errors';
import { checkIsInStoreOnlyReturn } from '../components/return-method/ReturnMethodHelper';
import { useReturnStore } from '../stores/returnStore';

export const GetReturnsEligibilityDetails = (
  requestData: IReturnEligibilityRequest,
  setReturnEligibilityDetails: (data: IReturnEligibilityResponse) => void,
  setAlertState: (value: IReturnsAlert | null) => void,
) =>
  ReturnEligibilityAPI(requestData)
    .then((response: AxiosResponse<IReturnEligibilityResponse>) => {
      setAlertState(null);
      setReturnEligibilityDetails(response.data);
      return response.data;
    })
    .catch((error: AxiosError<IGenericError>) => {
      const isNetworkError =
        error?.response?.status === 500 ||
        error?.code === 'ERR_NETWORK' ||
        error?.code === 'ECONNABORTED';
      TagApiError(error);

      if (isNetworkError) {
        setAlertState({
          type: 'NETWORK',
          status: 'error',
        });
        throw new Error('NETWORK');
      }
      setAlertState({
        type: 'GENERIC',
        status: 'error',
      });
      throw new Error('GENERIC');
    });

/**
 * Returns true if the order is only eligible for in-store returns (not UPS or LORP eligible)
 */
export const useIsInStoreOnlyReturn = () => {
  const orderDetailsV2 = useReturnStore((state) => state.orderDetailsV2);
  const returnEligibilityDetails = useReturnStore(
    (state) => state.returnEligibilityDetails,
  );
  const [isInStoreOnlyReturn, setIsInStoreOnlyReturn] = useState(false);

  useEffect(() => {
    if (returnEligibilityDetails && orderDetailsV2) {
      const isInStoreOnly = checkIsInStoreOnlyReturn(
        orderDetailsV2,
        returnEligibilityDetails,
      );
      setIsInStoreOnlyReturn(isInStoreOnly);
    }
  }, [returnEligibilityDetails]);

  return isInStoreOnlyReturn;
};
